import { SquarespaceIndustry } from '__generated__/types';

export const getIndustry = (industry: SquarespaceIndustry) => {
    switch (industry) {
        case SquarespaceIndustry.ACCOUNTING_AND_FINANCIAL:
            return __('Accounting & financial');
        case SquarespaceIndustry.ART_AND_DESIGN:
            return __('Art & design');
        case SquarespaceIndustry.BEAUTY_AND_PERSONAL_CARE:
            return __('Beauty & personal care');
        case SquarespaceIndustry.COMMUNITY_AND_NONPROFIT:
            return __('Community & nonprofit');
        case SquarespaceIndustry.ENTERTAINMENT_AND_MEDIA:
            return __('Entertainment & media');
        case SquarespaceIndustry.FASHION:
            return __('Fashion');
        case SquarespaceIndustry.FOOD_AND_DRINK:
            return __('Food & drink');
        case SquarespaceIndustry.HEALTH_AND_FITNESS:
            return __('Health & fitness');
        case SquarespaceIndustry.HOME_AND_LIVING:
            return __('Home & living');
        case SquarespaceIndustry.INTERIOR_DESIGN:
            return __('Interior design');
        case SquarespaceIndustry.LEGAL_SERVICES_AND_ATTORNEYS:
            return __('Legal services & attorneys');
        case SquarespaceIndustry.MARKETING_AND_ADVERTISING:
            return __('Marketing & advertising');
        case SquarespaceIndustry.MUSIC:
            return __('Music');
        case SquarespaceIndustry.PHOTOGRAPHY:
            return __('Photography');
        case SquarespaceIndustry.REAL_ESTATE:
            return __('Real estate');
        case SquarespaceIndustry.RETAIL_RESTAURANT_AND_BAR:
            return __('Retail, restaurant & bar');
        case SquarespaceIndustry.TECHNOLOGY:
            return __('Technology');
        case SquarespaceIndustry.TRAVEL_AND_LIFESTYLE:
            return __('Travel & lifestyle');
        case SquarespaceIndustry.WEDDING:
            return __('Wedding');
        default:
            return industry;
    }
};
